import http from "./http";
export const toApiError = (err) => {
  const data = err?.response?.data;

  const message =
    (typeof data === "string" && data.trim() ? data : null) ||
    data?.detail ||
    data?.message ||
    err?.message ||
    "مشکلی پیش آمد. دوباره تلاش کنید.";

  const e = new Error(message);
  e.code = data?.error || null; // مثلاً "expired_code"
  e.status = err?.response?.status || null;
  return e;
};

export const getStoreData = (store_id, params = {}) =>
  http.get(`/pro-majazi/stores/${store_id}/`, { params });

export const buyToken = (payload = {}) =>
  http.post(`/pro-majazi/tokens/buy/`, {
    shop_id: payload.shop_id,
    token_count: payload.token_count,
    method: payload.method,
    deposit_id: payload.deposit_id,
    total_price: payload.total_price,
  });

export const dailyLimit = (storeId, payload = {}) =>
  http.put(`/pro-majazi/shops/${storeId}/daily-limit/`, {
    unlimited: payload.unlimited,
    daily_limit: payload.daily_limit,
  });

export const getAdminStoresData = () => http.get(`/pro-majazi/admin/shops`);

export const getAdminPaymentsData = () =>
  http.get(`/pro-majazi/admin/payments`);

export const getAdminSettingData = () => http.get(`/pro-majazi/admin/settings`);
export const getShopCustomers = (store_id, sort) =>
  http.get(`/pro-majazi/admin/shops/${store_id}/customers`, {
    params: { sort },
  });

export const status_token = (purchase_id, payload = {}) =>
  http.post(`/pro-majazi/admin/card-purchases/${purchase_id}/review/`, {
    action: payload,
  });

export const getUsdtPrice = () => http.get(`/pro-majazi/usdt-price/`);

export const hasProMajazi = (store_id) => http.get(`/pro-majazi/${store_id}`);

export const sendProMajaziOtp = (phone) =>
  http.post("/pro-majazi/send-otp/", { phone_number: phone });

export const verifyProMajaziOtp = async (phone, code) => {
  try {
    const res = await http.post("/pro-majazi/verify-otp/", {
      phone_number: phone,
      code,
    });
    return res.data;
  } catch (err) {
    throw toApiError(err);
  }
};
